import DSC_8984 from '../assets/images/aboutSlider/MyImage2.jpg';
import DSC_9106 from '../assets/images/aboutSlider/PortImage5.jpg';
import DSC_9149 from '../assets/images/aboutSlider/DSC_9149.jpg';
import DSC_9188 from '../assets/images/aboutSlider/DSC_9188.jpg';
import DSC_9200 from '../assets/images/aboutSlider/DSC_9200.jpg';
import DSC_9214 from '../assets/images/aboutSlider/DSC_9214.jpg';
import DSC_9229 from '../assets/images/aboutSlider/DSC_9229.jpg';
import DSC_9349 from '../assets/images/aboutSlider/DSC_9349.jpg';











export const data = [
	{
		img: DSC_8984,
		altText: 'I Enjoy Writing Codes',
		headerText:
			'I Enjoy Writing Codes',
		descText:
			'I am a passionate and dedicated  Software Developer adept at building web from front to back with so much efficiency and accuracy.Through bootcamps, online courses, i have developed a strong understanding of Javascript(ES5 & Es6), React Js, Node.Js, Express.Js, MongoDB, HTML%, CSS3. I find a lot of joy and excitement utilizing my skills in bringing ideas to life, troubleshooting bugs, and pushing my projects forward',
		images: [
			DSC_8984,
			DSC_9106,
			DSC_9149,
			DSC_9188,
			DSC_9200,
			DSC_9214,
			DSC_9229,
			DSC_9349,
		],
		details: [
			{
				id: 1,
				desc:
					'During a courtesy visit by a delegation from the Lagos State Ministry of Energy and Mineral Resources, the MD/CEO of MOJEC International, Ms Chantelle Abdul, reiterated the firm’s commitment in solving issues around metering since its inception.',
			},
			{
				id: 2,
				desc:
					'Ms. Abdul makes her intention known on partnership with the state government to ensure the transformation of the energy sector, closing the metering gap and providing affordable meters to electricity consumers.',
			},
			{
				id: 3,
				desc:
					'As described by her, “Lagos State stands as the state that contributes the most to the national GDP, and as such, any solutions to a nationwide problem should be coming out of Lagos. I couldn’t be happier that you have owned and pioneered providing solutions to the challenges affecting the metering segment of the energy sector.',
			},
			{
				id: 4,
				desc:
					'I am excited the government is having discussions with us to bridge the metering gap through local manufacturers as opposed to completely relying on importation. Importing meters into the country will not close the gap as fast as everyone thinks and this is because procurement is not the issue but the manpower and other factors that go into getting these meters on the walls of the end users.',
			},
			{
				id: 5,
				desc:
					'Therefore, in our engagement with the government, we continue to let them know that manufacturers are available in the country and we are able to produce these meters to the quantum of the immediate need of the country.',
			},
			{
				id: 6,
				desc:
					'Also speaking, the leader of the delegation and Commissioner for Energy and Mineral Resources, Mr. Olalere Odusote, congratulated MOJEC on its strides and the accolades it has been receiving.',
			},
			{
				id: 7,
				desc:
					'As said by Odusote, “What I have seen here is interesting, it is very impressive for us. We like the fact that there is a local company that is looking at helping us to solve our local problems rather than trying to import our way out of the problem.”',
			},
			{
				id: 8,
				desc:
					'While speaking on the next step for the Lagos Smart Meter hackathon winners, he stated that their meter prototypes will be refined after which a few meters will be produced for testing, adding that the next phase after that will be to engage meter manufacturers on how the IP can be leased to them for mass production.',
			},
			{
				id: 9,
				desc:
					'MOJEC’s commitment to close the metering gap was further reiterated recently with the sponsorship of the Lagos Smart Meter Hackathon, an initiative of the Lagos State Government, created to leverage the availability of local talents in Nigeria to develop and produce affordable smart electricity meters for consumers.',
			},
			{
				id: 10,
				desc:
					'Aside from closing the meter gap, this will also help in reducing revenue losses and ultimately improve last-mile electricity supply.',
			},
			{
				id: 11,
				desc:
					'MOJEC International is the largest meter manufacturer in Nigeria. As a leading indigenous manufacturer and contractor to power utilities in Nigeria and across the western hemisphere, MOJEC has an installed production capacity of up to four million meters annually.',
			},
			{
				id: 12,
				desc:
					'Presently, MOJEC remains at the forefront of metering technology and boasts over 60 per cent market penetration rate in the Nigerian electricity market with over nine out of 11 of the utilities as clients.',
			},
			{
				id: 13,
				desc:
					'Ms. Abdul explained that, “With ambitious future plans for growth, we aim to further entrench our leadership in the Nigerian power sector through research and development, training in human capital and investment in infrastructure, our people, products and processes.” ',
			},
		],
	},
	{
		img: DSC_8984,
		altText: 'I Love Learning',
		headerText: 'I Love Learning',
		descText:
			'I am open to all kinds of business ideas, job opportunities, open source projects and more. Feel free to connect with me! Let us talk about web dev, web design and anything related to tech. I would also like to know how i can be of help to your business or team.I am looking to collaborate and work with other passionate developers and expand my network.',
		images: [
			DSC_8984,
            DSC_9106,
            DSC_9149,
            DSC_9188,
            DSC_9200,
            DSC_9214,
            DSC_9229,
            DSC_9349,
				
		],
		details: [
			{
				id: 1,
				desc:
					'MOJEC International Limited donates two million Naira to the first runner-up at the just concluded Lagos Smart Meter Hackathon,  an initiative of the Lagos State government in collaboration with the Eko Innovation Centre to engage local technological talents to design and produce smart and affordable meters in order to bridge the metering gap in Lagos State and Nigeria as a whole.',
			},
			{
				id: 2,
				desc:
					'As an actualization of its commitment to bridging the metering gap in the Nigerian power sector, MOJEC International did not hesitate to sponsor the hackathon at the Silver level. Two hundred and seven (274) participants registered for the hackathon in the software and hardware categories while only 65 hardware and software prototypes were submitted by applicants, with 10 teams emerged as the finalists. The shortlisted finalists under the hardware category were: Cosmo Automation, Smart Energy, Techwizard, Power Bit Crunchers, and Gadozz Electricals. And the software finalists were Vectorians, Zeena Platform, Magnitronics, Chosen Soft-Tech, and Gideon. The 3-day event which was held on the 16th-18th of September 2020 had the 10 shortlisted finalists pitching their innovative hardware and software ideas to a panel of 8 judges, one of which was Chantelle Abdul, Managing Director and CEO of MOJEC. ',
			},
			{
				id: 3,
				desc:
					'While speaking at the Grand Finale of the hackathon on behalf of the judges, Ms Chantelle Abdul expressed her delight and satisfaction with the exceptionally innovative ideas and creations of the finalist teams. “I am quite thrilled that Nigeria has the capacity and technological know-how to produce meters in Nigeria. It is a dream come true. These past 2 days have been eye-opening. What I am truly elated about is that I saw young Nigerians do brilliantly, in a short period of time do what we have tried to spend months sourcing out of Nigeria. I must also say that we as manufacturers and the DisCos are committed to developing this industry in Nigeria and ensuring that we continue to create jobs by producing meters in the country. I am super excited today that a lot of what we procure from China are actually purchased and available here in Nigeria. “ After a rigorous assessment by the panel of judges, Team Power Bit Crunchers (hardware) and Team Zeena Platform emerged winners of the hackathon. They will be working together to create smart and affordable smart meters. The first runners-up are Team Magnitronics and Team Cosmo Automation, who will be going home with 2 Million Naira donated by Ms. Chantelle. Although the grand prize was raised from N7 million to N10 million by the opening of the Grand Final, Ms. Abdul made a generous donation for the first runners-up. This is in a bid to appreciate and encourage the efforts of the teams. In her words “We are always only looking at the winner but the truth of the matter is everybody else tries so hard. Therefore, I would like to, on behalf of my firm, donate a sum of N2 million for the first runner up.”',
			},
		],
	},
];
